// extracted by mini-css-extract-plugin
export default {"preloader":"preloader_preloader__cUl6v","icon":"preloader_icon__1OSl4","spinner":"preloader_spinner__oHcs5"};